module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAAAXNSR0IArs4c6QAAAMlJREFUKFO9kDFrwlAUhc97dy1UxD1z1wz+lYKDRJ65Szc36SBZ6+IihHCzpVDIn3DxZ3Ts4BSpm5B3S0IooQ2OnvHccy58x8RxvAUQqupMRE4YkHNubK0tAHya5s7MLwBWdV3P8zw/9jvMHAL4ACBZlr21hUbOuSkRvXvv9yKy67wlEb167xcicmg8E0XRKAiC7yRJPDNPVLUwxpwBXFT1iYie0zT96rKPZoDBMvMawENVVZuyLK93ZvizyC2GNvq7Uq/4j6H/9AcQPX++8FnpoAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_zhankai_nor.png
// module id = VDhO
// module chunks = 1